import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

export function getCookie(name: string) {
  if (Capacitor.getPlatform() === 'web') {
    return document.cookie.split(";").some((c) => {
      return c.trim().startsWith(name + "=");
    });
  }
  
  return false;
}

export async function setNativeCookie(
  name: string,
  value: string,
  expires: string,
) {
  const expirationDate = new Date(expires);
  const cookieName = name.split("_native_cookie").join("");
  
  if (Capacitor.getPlatform() === 'web') {
    document.cookie = `${cookieName}=${value}; expires=${expirationDate.toUTCString()}; path=/; domain=${window.location.hostname}`;
  } else {
    await Preferences.set({
      key: `cookie_${cookieName}`,
      value: JSON.stringify({
        value,
        expires: expirationDate.toISOString()
      })
    });
  }
  
  return true;
}

export async function getNativeCookie(name: string): Promise<string | null> {
  if (Capacitor.getPlatform() === 'web') {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [key, value] = cookie.trim().split('=');
      if (key === name) return value;
    }
    return null;
  }
  
  const { value } = await Preferences.get({ key: `cookie_${name}` });
  if (value) {
    const data = JSON.parse(value);
    if (new Date(data.expires) > new Date()) {
      return data.value;
    }
    await Preferences.remove({ key: `cookie_${name}` });
  }
  return null;
}

export async function clearAllCookies(): Promise<void> {
  if (Capacitor.getPlatform() === 'web') {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const name = cookie.trim().split('=')[0];
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  } else {
    const keysResult = await Preferences.keys();
    const cookieKeys = keysResult.keys.filter(key => key.startsWith('cookie_'));
    
    for (const key of cookieKeys) {
      await Preferences.remove({ key });
    }
  }
}